module.exports = __webpack_public_path__ + "img/party-popper.7120bf55.svg";